import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=18c004ac"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports